import React from "react";

export default function Error404() {
  return <h1>404!</h1>;
}
